import api from '../api';

import { ParamsBodyEditCustomerAppEmergencyContacts } from 'utils/typeServices';

export const PostEditCustomerAppEmergencyContacts = async ({ token, body }: { token: string, body: ParamsBodyEditCustomerAppEmergencyContacts }) => {
    const bodyJson = JSON.stringify(body);

    try {
        const { data } = await api.post<{ Data: any }>('/v1/Cliente/EditCustomerAppEmergencyContacts', bodyJson, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
